<template>
  <div class="col-span-2 mx-auto overflow-hidden rounded-lg shadow-lg lg:flex">
    <div class="flex-1 px-6 py-8 bg-white lg:p-12">
      <h3 class="flex items-center">
        <img src="@/assets/img/logo-signal.svg" alt="Fleetbeacon Signal" class="h-12 mr-4">
        <div class="text-xl leading-none uppercase">
          <div class="font-extrabold">
            Fleetbeacon
          </div>
          <div class="font-medium text-purple-500">
            Signal
          </div>
        </div>
      </h3>
      <p class="mt-4 text-base text-gray-500">
        The growth of your business is our priority, so we've designed our pricing with that in mind: only pay per vehicle in your fleet.
      </p>
      <div class="mt-8">
        <div class="flex items-center">
          <div class="flex-1 h-px bg-gray-200"></div>
          <h4 class="flex-shrink-0 px-3 text-xs font-semibold tracking-wider text-gray-600 uppercase bg-gray-200 rounded-full">
            What's included
          </h4>
          <div class="flex-1 h-px bg-gray-200"></div>
        </div>
        <ul class="grid gap-8 mt-8 lg:grid-cols-2">
          <li class="flex items-start rounded-md lg:col-span-1" v-for="feature in features" :key="feature.icon">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center flex-none mt-1 text-gray-400 rounded">
                <fa :icon="['fas', feature.icon]" fixed-width />
              </div>
            </div>
            <div class="ml-3">
              <p class="font-bold">
                {{ feature.name }}
              </p>
              <p class="text-sm mt-0.5 text-gray-500">
                {{ feature.summary }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="px-6 py-8 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12">
      <div>
        <div class="mb-2 text-sm font-medium leading-6 tracking-widest text-purple-500 uppercase">
          From Only
        </div>
        <div class="flex items-center justify-center my-2 text-6xl font-extrabold leading-none tracking-tight">
          {{ currency.symbol }}{{ vehiclePrice }}
          <div class="ml-2 text-lg tracking-wide text-gray-500">{{ currency.code }}</div>
        </div>
        <div class="mt-2 text-sm font-medium leading-6 tracking-widest text-purple-500 uppercase">
          per vehicle <br> billed monthly
        </div>
        <p class="max-w-xs mx-auto mt-4 text-center text-gray-500">
          No contracts or lock-in. Pay month-to-month and cancel any time.
        </p>
      </div>
      <div class="mt-6">
        <router-link :to="{ name: 'Request' }" class="w-full max-w-xs text-white btn btn-xl hover:opacity-90 btn-purple">
          Start a Free Trial
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { features } from '@/store/products/signal'

export default {
  name: 'PricingRadar',

  computed: {
    currency () {
      if (this.$cookies.get('currency_code') === 'EUR') {
        return { code: 'EUR', symbol: '€' }
      } else if (this.$cookies.get('currency_code') === 'ZAR') {
        return { code: 'ZAR', symbol: 'R' }
      } else if (this.$cookies.get('currency_code') === 'GBP') {
        return { code: 'GBP', symbol: '￡' }
      } else if (this.$cookies.get('currency_code') === 'NZD') {
        return { code: 'NZD', symbol: '$' }
      } else if (this.$cookies.get('currency_code') === 'AUD') {
        return { code: 'AUD', symbol: '$' }
      } else {
        return { code: 'USD', symbol: '$' }
      }
    },

    orderPrice () {
      return this.currency.code === 'ZAR' ? '2.50' : '0.25'
    },

    vehiclePrice () {
      return this.currency.code === 'ZAR' ? '50' : '5'
    },

    basePrice () {
      return this.currency.code === 'ZAR' ? '500' : '50'
    }
  },

  data () {
    return {
      features
    }
  }
}
</script>